<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!----------------------------------LOS 4 TABS DEL COMPONENTE----------------------->
    <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
      slider-color="#ffbc00">
      <v-tab class="font-weight-black">AÑO LECTIVO </v-tab>
      <v-tab class="font-weight-black">NIVELES Y GRADOS</v-tab>
      <v-tab class="font-weight-black" @click="getAllAnoLectivosActivos">PERIODOS VIGENTES</v-tab>
      <v-tab class="font-weight-black" @click="getAllAnoLectivosActivos">CALENDARIO ACADÉMICO</v-tab>
      <v-tab class="font-weight-black">HORARIO ACADÉMICO</v-tab>
      <!-- <v-tab class="font-weight-black">CIERRE DE NOTAS POR PERÍODO</v-tab> -->
    </v-tabs>
    <!----------------------------------VISTA DE AÑO LECTIVO-------------------------->
    <v-tabs-items v-model="tab">
      <v-tab-item class="mt-2">
        <!-- boton crear -->
        <v-row>
          <v-col class="d-flex flex-row-reverse">
            <ButtonComp normalButton v-if="componenteEvento.agregar_submodulo" @click="aggAnoLectivo"
              iconBut="fas fa-plus" textButton="Crear año lectivo" />
          </v-col>
          <v-col cols="12">
            <ComundataTablecomp :headers="AnoelectivoHeaders" :items="ano_lectivo" :search="search" whitSearch>
              <template v-slot:fecha_inicioFiltro="{ item }">
                {{ item.fecha_inicio | filtroFecha }}
              </template>

              <template v-slot:fecha_cierreFiltro="{ item }">
                {{ item.fecha_cierre | filtroFecha }}
              </template>

              <!--  CIERRE DEL AÑO IN PROGRESS (CUANDO TERMINE LO DE IBC Y EL CONSOLIDADO ME METO CON ESA VAINILLA) -->
              <template v-slot:estado="{ item }">
                <v-chip v-if="item.flag_cierre === 0" small class="color_inactivo">
                  Cerrado
                </v-chip>
                <v-chip v-if="item.flag_cierre === 1" small class="color_activo">
                  Activo
                </v-chip>
              </template>

              <template v-slot:action_editar="{ item }">
                <ButtonComp v-if="item.flag_cierre === 1 && componenteEvento.editar_submodulo" @click="editItem(item)"
                  editButton tooltipText="Editar año lectivo" />
              </template>

              <template v-slot:action_eliminar="{ item }">
                <ButtonComp v-if="componenteEvento.editar_submodulo" @click="deleteItem(item)" deleteButton
                  tooltipText="Eliminar año lectivo" />
              </template>
            </ComundataTablecomp>

          </v-col>
        </v-row>



      </v-tab-item>

      <!----------------------------------VISTA DE NIVELES Y GRADOS ----------------->
      <v-tab-item class="mt-2">
        <NivelGrados />
      </v-tab-item>


      <!----------------------------------VISTA DE PERIODOS VIGENTES-------------------->
      <v-tab-item class="mt-2">
        <!-- boton crear -->
        <v-row v-if="componenteEvento.agregar_submodulo">
          <v-col class="d-flex flex-row-reverse">
            <ButtonComp @click="aggPeriodo" iconBut="fas fa-plus" textButton="Crear periodo" normalButton />
          </v-col>
        </v-row>

        <v-col cols="12">
          <ComundataTablecomp :headers="PeriodosHeaders" :items="Periodos" :search="search2" whitSearch>
            <template v-slot:fecha_inicioFiltro="{ item }">
              {{ item.fecha_inicio | filtroFecha }}
            </template>

            <template v-slot:fecha_cierreFiltro="{ item }">
              {{ item.fecha_cierre | filtroFecha }}
            </template>

            <template v-slot:nivel="{ item }">
              <div class="chip" :style="{ background: item.color }">
                {{ item.desc_nivel }}
              </div>
            </template>


            <template v-slot:status="{ item }">
              <v-chip v-if="item.fecha_inicio <= now && item.fecha_cierre < now" small class="color_inactivo">
                Cerrado
              </v-chip>
              <v-chip v-else-if="item.fecha_inicio <= now && item.fecha_cierre >= now" small class="color_activo">
                Activo
              </v-chip>
              <v-chip v-else-if="item.fecha_inicio >= now && item.fecha_cierre >= now">
                Sin Iniciar
              </v-chip>
            </template>

            <template v-slot:action_editar="{ item }">
              <ButtonComp v-if="item.estado_periodo === 1 && componenteEvento.editar_submodulo" @click="editItem2(item)"
                tooltipText="Editar periodo" editButton :disabled="item.status == 0"/>
            </template>

            <template v-slot:action_eliminar="{ item }">
              <ButtonComp v-if="componenteEvento.editar_submodulo" @click="deleteItem2(item)" deleteButton
                tooltipText="Eliminar periodo" :disabled="item.status == 0"/>
            </template>
          </ComundataTablecomp>
        </v-col>
      </v-tab-item>

      <!----------------------------------VISTA DE CALENDARIO ACADEMICO----------------->
      <v-tab-item class="mt-2">
        <v-card>
          <v-card-title>Configuración del calendario académico</v-card-title>
          <v-card-text>
            <p>
              Los días que no están seleccionados se omiten del calendario escolar
              y no serán tomados en cuenta para el cálculo de inasistencias al
              colegio
            </p>
            <v-row class="d-flex justify-center">
              <v-col cols="12" md="auto" v-for="day in diasSemanas" :key="day.id">
                <v-card>
                  <v-card-title class="d-flex justify-center align-center px-4 mt-2 pa-0 mx-0">
                    <v-card-text class="justify pa-1 mx-0 justify-center" cols="12" md="7" sm="6">{{ day.nombre_dia
                    }}</v-card-text>
                    <v-checkbox class="d-flex justify-start pa-0" v-model="day.selected"
                      @change="capturarSeleccion(day)"></v-checkbox>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-container
                    class="px-0"
                    fluid
                  >
                    <v-switch
                      v-model="switch1"
                      :label="`¿Deseas activar temporalmente el calendario para incluir Sabados y Domingo?`"
                      @change="toggleModal"
                    ></v-switch>
                  </v-container>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <ButtonComp normalButton iconBut="fas fa-save" textButton="Guardar" @click="enviarSeleccion()" />
          </v-card-actions>
        </v-card>

        <ComunDialogComp v-model="modalOpen" @close-modal="closeModal" persistent max-width="600px" :title="title">
          <template v-slot:body>
            <v-card>
              <v-card-text class="text-h6">Días que desea habilitar</v-card-text>
              <v-container>
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                      v-model="sabadoSeleccionado"
                        label="Sábado"
                        value="6"
                        @change="actualizarDiasFinDeSemana(6)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-checkbox
                      v-model="domingoSeleccionado"
                        label="Domingo"
                        value="0"
                        @change="actualizarDiasFinDeSemana(0)"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>

                <v-col cols="12" sm="8">
                  <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="dateDisplay"
                    label="Día de finalización personalizada"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedDate"
                    :allowed-dates="allowedDates"
                    no-title
                    scrollable
                    @input="onDateSelected"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <ButtonComp normalButton textButton="Cancelar" classColor="red"
                   classButton="ml-2" @click="closeModal" />
                <ButtonComp normalButton iconBut="fas fa-save" textButton="Guardar" @click="enviarSeleccion()" />
              </v-card-actions>
            </v-card>
          </template>
        </ComunDialogComp>
        
        <v-card>
          <v-card-title>
            Configuración de feriados y días no laborables

          </v-card-title>
          <v-card-text>
            Las fechas añadidas en las siguientes listas se consideran no
            laborables y se omiten para el cálculo de la asistencia.
            <v-row dense>
              <v-col class="d-flex flex-row-reverse">
                <ButtonComp textButton="Agregar feriado" iconBut="fas fa-plus" normalButton @click="verCalendario" />
              </v-col>
              <v-col cols="12" :items="filtrarItemsPorAnoLectivo(ano_lectivo.id)" :headers="headersferiadosCalendario" item-key="id">
                <span>{{ lectivo.nom_anolectivo }}</span>
                <ComundataTablecomp :items="items3" :headers="headersferiadosCalendario" item-key="id">
                  <template v-slot:start="{ item }">
                    {{ item.start | filtroFecha }}
                  </template>

                  <template v-slot:end="{ item }">
                    {{ item.end | filtroFecha }}
                  </template>

                  <template v-slot:action_editar="{ item }">
                    <ButtonComp @click="openModalFeriado(item)" tooltipText="Editar feriado académico" editButton />
                  </template>

                  <template v-slot:action_eliminar="{ item }">
                    <ButtonComp @click="deleteItemFeriado(item)" tooltipText="Eliminar feriado académico" deleteButton />
                  </template>
                </ComundataTablecomp>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item class="mt-2">
        <HorarioAcademico :diaHabil="idsSeleccionados" />
      </v-tab-item>

      <!-- --------------------------------VISTA DE CIERRE DE NOTAS--------------- -->
      <!--<v-tab-item class="mt-2">
        <CierreNotasPeriodo />
      </v-tab-item> -->


    </v-tabs-items>

    <!----------------------------------MODAL PARA CREAR AÑO LECTIVO------------------->

    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="lectivo" maxWidth="380" :title="formTitle" @close-modal="lectivo = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <textfieldComp textLabel="Nombre" v-model="editedAno.nom_anolectivo" type="text"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted" label="Fecha de inicio" readonly v-on="on"
                    :rules="validationRules.validateCampo"></v-text-field>
                </template>

                <v-date-picker v-model="editedAno.fecha_inicio" no-title :min="nowDate"
                  @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-menu v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted2" label="Fecha de cierre" readonly v-on="on"
                    :rules="validationRules.validateCampo"></v-text-field>
                </template>

                <v-date-picker v-model="editedAno.fecha_cierre" no-title :min="editedAno.fecha_inicio"
                  @input="menu3 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- <v-col cols="12" sm="6" md="12" class="py-0" v-if="evento != 'agregar'">
              <v-radio-group v-model="editedAno.flag_cierre" row label="Estado:">
                <v-radio v-for="n in Estados" :key="n.id" :label="n.nombre" :value="n.valor" :color="n.color">
                </v-radio>
              </v-radio-group>
            </v-col> -->
          </v-row>
        </template>

        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp v-if="evento === 'editar'" @click="editAnoLectivo(editedAno.id)" iconBut="fas fa-save" normalButton
            textButton="Guardar cambios" />
          <ButtonComp v-if="evento == 'agregar'" @click="addAnoLectivo" normalButton textButton="Guardar"
            iconBut="fas fa-save" />
          <ButtonComp @click="lectivo = false" classColor="red" classButton="ml-2" normalButton textButton="Cancelar" />

        </template>
      </ComunDialogComp>

    </v-form>
    <!----------------------------------FIN CREAR AÑO LECTIVO-------------------------->

    <!---------------------FIN DE CREAR PERIODOS CON CONFIGURACIONES PASADAS ---------->

    <!--------------------------------------------------------------------------------->
    <!----------------------------------MODAL AGREGAR PERIODO-------------------------->
    <v-form ref="formDatosPeriodo" lazy-validation>
      <ComunDialogComp v-model="modal_periodo" maxWidth="550" :title="formTitle2" @close-modal="modal_periodo = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <AutocompleteComp textLabel="Año lectivo" v-model="editedPeriodo.id_ano_lectivo" :items="anos_activos"
                item-text="nom_anolectivo" :rules="validationRules.validateCampo" item-value="id" />
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <textfieldComp textLabel="Nombre" v-model="editedPeriodo.nombre_periodo"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <AutocompleteComp textLabel="Niveles" v-model="editedPeriodo.id_nivel" :items="Niveles"
                item-value="id_nivel_adm_nivel" item-text="desc_nivel" multiple :rules="validationRules.validateCampo"
                :isDisable="evento2 == 'editar'" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-menu v-model="menu4" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted4" label="Fecha de inicio" readonly v-on="on"
                    :rules="validationRules.validateCampo"></v-text-field>
                </template>

                <v-date-picker v-model="editedPeriodo.fecha_inicio" no-title @input="menu4 = false" :min="mindatePeriodo"
                  :max="maxdatePeriodo"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-menu v-model="menu5" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted5" label="Fecha de cierre" readonly v-on="on"
                    :rules="validationRules.validateCampo"></v-text-field>
                </template>

                <v-date-picker v-model="editedPeriodo.fecha_cierre" no-title @input="menu5 = false"
                  :min="editedPeriodo.fecha_inicio" :max="maxdatePeriodo"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp v-if="evento2 == 'editar'" :disabled="bloquearBotonGurdar" normalButton textButton="Guardar cambios"
            iconBut="fas fa-save" @click="editPeriodo(editedPeriodo.id)" />
          <ButtonComp v-if="evento2 === 'agregar'" :disabled="bloquearBotonGurdar" @click="addPeriodos"
            iconBut="fas fa-save" normalButton textButton="Guardar" />
          <ButtonComp @click="modal_periodo = false" normalButton textButton="Cancelar" classColor="red"
            classButton="ml-2" />
        </template>
      </ComunDialogComp>

    </v-form>
    <!---fin modal agregar periodo-->

    <!--------------------------------------------------------------------------------->
    <!----------------------------------MODAL EDITAR FERIADO--------------------------->
    <v-form ref="formEditFeriado" lazy-validation>
      <ComunDialogComp v-model="modal_feriado" maxWidth="550" title="Editar feriado" @close-modal="modal_feriado = false">
        <template v-slot:body>
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <textfieldComp textLabel="Título" v-model="editedFeriado.name" />
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <textfieldComp textLabel="Detalle" v-model="editedFeriado.details" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-menu v-model="menu4" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field label="Fecha de inicio" v-model="computedDateFormatted6" readonly
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="editedFeriado.start" no-title @input="menu4 = false" :min="mindatePeriodo"
                  :max="maxdatePeriodo"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-menu v-model="menu5" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted7" label="Fecha de cierre" readonly
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="editedFeriado.end" no-title @input="menu5 = false"
                  :min="editedPeriodo.fecha_inicio" :max="maxdatePeriodo"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp @click="updateEvent(editedFeriado)" iconBut="fas fa-save" normalButton
            textButton="Guardar cambios" />
          <ButtonComp @click="modal_feriado = false" textButton="Cancelar" classColor="red" normalButton
            classButton="ml-2" />
        </template>
      </ComunDialogComp>

    </v-form>

    <!--------------------------------------------------------------------------------->
    <!----------------------------------MODAL CALENDARIO------------------------------->
    <ComunDialogComp v-model="dialog" maxWidth="750" @close-modal="dialog = false" title="Calendario académico">
      <template v-slot:body>
        <calendario-academico :diaHabil="idsSeleccionados"></calendario-academico>
      </template>
    </ComunDialogComp>


    <!-- MODAL - CONFIRM DELETE - LECTIVO -->
    <confirm v-if="confirm.type === 1" :titleWindow="confirm.titlewindow" @aceptar="deleted_lectivo"
      @cancelar="clear_confirm" :title="confirm.title" :active="confirm.active" />
    <!-- MODAL - CONFIRM DELETE - PERIODO -->
    <confirm v-else-if="confirm.type === 2" @aceptar="deleted_periodo" :titleWindow="confirm.titlewindow"
      @cancelar="clear_confirm" :title="confirm.title" :active="confirm.active" />

    <confirm @aceptar="deleteEvent" :titleWindow="confirm.titlewindow" @cancelar="clear_confirm" :title="confirm.title"
      :active="confirm.active" />
  </div>
</template>

<script>
import axios from "../../helpers/axios";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
// import BtnComp from "@/components/ComponentsEst/BtnComp.vue";
import CalendarioAcademico from "./CalendarioAcademico.vue";
import HorarioAcademico from './HorarioAcademico.vue';
// import CierreNotasPeriodo from '../SituacionDelEstudiante/components/CierreNotasPeriodo.vue';
import ButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../components/ComponentsEst/ComunDialogComp.vue';
import ComundataTablecomp from '../../components/ComponentsEst/ComundataTablecomp.vue';
import { AnoelectivoHeaders, PeriodosHeaders, headersferiadosCalendario } from '../../helpers/headersTable';
import textfieldComp from '../../components/ComponentsEst/textfieldComp.vue';
import { validationRules } from '../../helpers/validatorHelpers';
import AutocompleteComp from '../../components/ComponentsEst/AutocompleteComp.vue';
import NivelGrados from '../Administrativo/NivelesyGrados/adminGrados.vue'

export default {
  components: {
    // BtnComp,
    CalendarioAcademico,
    HorarioAcademico,
    // CierreNotasPeriodo,
    ButtonComp,
    ComundataTablecomp,
    ComunDialogComp,
    textfieldComp,
    AutocompleteComp,
    NivelGrados,
  },
  data: (vm) => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 12, id_modulo: 6 },
    tab: 0,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    AnoelectivoHeaders,
    PeriodosHeaders,
    headersferiadosCalendario,
    //---------- AÑO LECTIVO
    dialogOptionsAnioLectivo: false,

    //---------- MODAL DELETE CONFIRM
    confirm: {
      item: {},
      title: "",
      titlewindow: "",
      active: false,
      type: 0,
    },
    nowDate: new Date(new Date().getFullYear(), 0, 1)
      .toISOString()
      .slice(0, 10),

    mindatePeriodo: "2021-02-02",
    maxdatePeriodo: null,
    dateMinGlobal: null,
    search: "",
    ano_lectivo: [],
    bloquearBotonGurdar: false,
    dateDisplay:"",
    selectedDate:new Date().toISOString().substr(0, 10),
    menu:false,

    //variables para la activacion automatico
    selected:"Seleccione una fecha",
    sabadoSeleccionado:false,
    domingoSeleccionado:false,
    dateClean:"",

    now: new Date().toISOString().substr(0, 10),

    //---------- VALIDACIONES DEL FORMULARIO
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },

    //---------- FUNCIONES DEL DATE PICKER
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,

    //---------- MODAL AGREGAR/EDITAR AÑO LECTIVO
    evento: "",
    lectivo: false,
    editedAno: [],

    // Estados: [
    //   { nombre: "Activo", valor: 1, color: "teal" },
    //   { nombre: "Cerrar", valor: 0, color: "error" },
    // ],

    //////////////// PERIODO ///////////////
    search2: "",
    Periodos: [],
    PeriodosFuture: [],

    headersFuture: [
      {
        text: "NOMBRE DEL PERIODO",
        value: "nombre_periodo",
        class: "secondary black--text",
      },
      {
        text: "FECHA DE INICIO",
        value: "fecha_inicio",
        class: "secondary black--text",
      },
      {
        text: "FECHA DE CIERRE",
        value: "fecha_cierre",
        class: "secondary black--text",
      },
      {
        text: "NIVEL",
        align: "center",
        value: "desc_nivel",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "ESTADO",
        align: "center",
        value: "status",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "EDITAR",
        value: "action_editar",
        sortable: false,
        align: "center",
        class: "secondary black--text px-0 mx-0",
      },
      {
        text: "ELIMINAR",
        value: "action_eliminar",
        sortable: false,
        align: "center",
        class: "secondary black--text px-0 mx-0",
        width: "1",
      },
    ],

    //---------- MODAL AGREGAR/EDITAR PERIODO
    modal_periodo: false,
    evento2: "",
    editedPeriodo: [],
    anos_activos: [],
    Niveles: [],

    //----------  AÑO LECTIVO FUTURO USANDO CONFIGURACIONES DE AÑOS LECTIVOS PASADAS
    switchA: 0,

    //---------- MULTISTEP
    step: 1,


    //---------- DEFINICIÓN DE AÑO LECTIVO
    globalAnoLectivo: 0,

    date: new Date().toISOString().substr(0, 10),

    nivelParams: {
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio_adm_nivel: sessionStorage.id_colegio,
    },

    //---------- VARIABLES DEL CALENDARIO ACADEMICO
    diasSemanas: [],
    diasSeleccionados: [], // almacenara los dias seleccionados
    datos: {}, // objetos para enviar el post
    dialog: false,
    idsSeleccionados: [],
    items3: [],
    modal_feriado: false,
    editedFeriado: {},
    switch1: false,
    modalOpen: false, 
    title: "Activar temporalmente"
  }),

  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.diaFeriado();
      }
    },
    switchA(newValue) {
      console.log("revisar",newValue)
    },

    selectedDate(val) {
      this.dateDisplay = this.formatDate(val); // Asegura que la fecha se muestre en el formato deseado
    }
  },

  async created() {
    await this.actualizarParamentro();
    this.diasSelect();
  },

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    ...mapState({ fechasFeriado: 'fechasFeriado' }),

    computedSwitchA: {
      get() {
        return this.switchA;
      },
      set(value) {
        this.switchA = value ? 1 : 0;
      }
    },

    validationRules() {
      return validationRules;
    },

    computedDateFormatted() {
      return this.formatDate(this.editedAno.fecha_inicio);
    },

    computedDateFormatted2() {
      return this.formatDate(this.editedAno.fecha_cierre);
    },

    computedDateFormatted4() {
      return this.formatDate(this.editedPeriodo.fecha_inicio);
    },

    computedDateFormatted5() {
      return this.formatDate(this.editedPeriodo.fecha_cierre);
    },

    computedDateFormatted6() {
      return this.formatDate(this.editedFeriado.start);
    },

    computedDateFormatted7() {
      return this.formatDate(this.editedFeriado.end);
    },

    formTitle() {
      return this.evento === "agregar"
        ? "Crear año lectivo"
        : "Editar año lectivo";
    },

    formTitle2() {
      return this.evento2 === "agregar" ? "Crear periodo" : "Editar periodo";
    },

    diasSeleccionadoss() {
      return this.diasSemanas.filter((day) => day.selected);
    },

    items3ConFechasFormateadas() {
      return this.items3.map(item => ({
        ...item,
        start: this.formatDate(item.start),
        end: this.formatDate(item.end),
      }));
    },

  },

  mounted() {

    setTimeout(() => {
      this.getAllAnoLectivos();
      this.getAllAnoLectivosActivos();
      this.getAllNivelesAdmin();
      this.getAllPeriodos();

    }, 1000);

    this.getDiasDeLaSemana();
    this.diasSelect();
    this.diaFeriado()
    this.getFeriadosAcademicos();

  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    async actualizarParamentro() {
      await this.parametroComponente(this.paramComponente);
    },

    //---------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]), // no borrar funcion de enviar mensajes nueva 04/15/2020 kinverly
    ////////////////////////////////////////////////////////

    // loadMain() {
    //   this.getAllAnoLectivos();
    //   this.getAllAnoLectivosActivos();
    //   this.getAllNivelesAdmin();
    //   this.getAllPeriodos();
    // },

    //---------- input tipo fecha  --------
    allowedDates(date) {
      const today = new Date();
      const currentDate = new Date(date);
      return currentDate >= today;
    },
    onDateSelected(date) {
      this.dateDisplay = this.formatDate(date); 
      this.menu = false; 
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
 

    //---------- SALIR DEL SISTEMA --------------------------
    ...mapActions("login", ["logout"]),

    //---------- CONSULTA PRINCIPAL DEL AÑO LECTIVO ---------
    // tablas de años anteriores//
    async getAllAnoLectivos() {
      try {
        let response = await axios.get(
          "/administrativo/anoLectivo/all/" + this.datoLogin.id_colegio + ""
        );
        this.ano_lectivo = response.data;
       
       
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    filtrarItemsPorAnoLectivo(anoLectivoId) {
    return this.items3.filter(item => item.ano_lectivo === anoLectivoId);
  },

    clear_confirm() {
      this.confirm.item = {};
      this.confirm.title = "";
      this.confirm.active = false;
      this.confirm.type = 0;
    },

    async limpiarForm() {
      (this.editedAno = {
        id: 0,
        id_colegio: this.datoLogin.id_colegio,
        nom_anolectivo: "",
        fecha_inicio: "",
        fecha_cierre: "",
        flag_cierre: 1,
        id_usuario: this.datoLogin.id,
        estado_anolectivo: 1,
      }),
        this.resetValidation();
      this.clear_confirm();
    },

    //---------- VALIDAR RESETEAR CAMPOS AL GUARDAR --------
    resetValidation() {
      this.$refs.formDatos.resetValidation();
      this.$refs.formDatosPeriodo.resetValidation();
    },
    //---------- [AÑOS LECTIVOS] -------- 
    async getAllAnoLectivosActivos() {

      try {
        let response = await axios.get(
          "/administrativo/anoLectivo/estado/" + this.datoLogin.id_colegio + ""
        );
       

        if (response.data.length > 0) {
          this.dateMinGlobal = await response.data[0].fecha_inicio;
          this.mindatePeriodo = await response.data[0].fecha_inicio;
        }

        if (response.data.length > 0) {
          this.maxdatePeriodo = await response.data[0].fecha_cierre;
        }
      
        this.getAllNivelesAdmin();
        this.anos_activos = await response.data;


      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //---------- MODAL AGREGAR/EDITAR AÑOS LECTIVOS
    aggAnoLectivo() {
      if (this.anos_activos.length != 0) {
        this.setEnviarMens({
          tipo: "W",
          mensaje:
            "Existe un año lectivo activo, debe cerrarlo para crear uno nuevo.",
          tiempo: null,
        });
      } else {
        this.lectivo = true;
        this.evento = "agregar";
        this.limpiarForm();
      }

      //Luego borrar ()
      //this.lectivo = true;
      // this.evento = "agregar";
      this.limpiarForm();
    },

    //---------- FUNCIÓN CREAR AÑO LECTIVO --------------------
    async addAnoLectivo() {
      if (this.$refs.formDatos.validate()) {
        let params = this.editedAno;

        try {
          let response = await axios.post("/administrativo/anoLectivo", params);
          this.getAllAnoLectivos();
          this.getAllAnoLectivosActivos();

          if (
            this.datoLogin.id_ano_lectivo == "undefined" ||
            this.datoLogin.id_ano_lectivo == " " ||
            this.datoLogin.id_ano_lectivo === 0 ||
            this.datoLogin.id_ano_lectivo === "0" ||
            this.datoLogin.id_ano_lectivo === null
          ) {
            sessionStorage.setItem("id_ano_lectivo", response.data.data.id);
          }
          this.lectivo = false;
          this.limpiarForm();

          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Información creada con éxito!",
            tiempo: null,
          });
          this.switchA = 0;
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });

        }
      }
    },

    //---------- MODAL EDITAR AÑO LECTIVO -------
    editItem(item) {
      this.evento = "editar";
      this.lectivo = true;
      this.limpiarForm();
      this.editedAno = Object.assign({}, item);
    },

    //---------- FUNCIÓN EDITAR AÑO LECTIVO -------------
    async editAnoLectivo(id) {
      if (this.$refs.formDatos.validate()) {
        let params = this.editedAno;
        params.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        try {
          //Condicional para cerrar año lectivo, es necesario que se cree el sigueinte año lectivo
          if (params.flag_cierre === 0) {
            this.setEnviarMens({
              tipo: 'W',
              mensaje: "Para poder cerrar el año lectivo actual, es obligatorio crear el siguiente.",
              tiempo: null,
            });
            
          } else {
            //En caso no se quiera cerrar y solo editar las fechas
            
            let response = await axios.put(
              "/administrativo/anoLectivo/" + id,
              params
            );


            this.setEnviarMens({
              tipo: response.data.messageT,
              mensaje: response.data.message,
              tiempo: null,
            });
            this.getAllAnoLectivos();
            this.getAllAnoLectivosActivos();
            this.lectivo = false;
            this.limpiarForm();
          }

        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    //---------- CONFIRMACIÓN DE ELIMINAR -------------------------
    async deleteItem(item) {
      this.confirm.item = item;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.titlewindow = "Eliminar año lectivo";
      this.confirm.active = true;
      this.confirm.type = 1;
    },

    //---------- METODO QUE PERMITE ELIMINAR UN AÑO LECTIVO, SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
    async deleted_lectivo() {
      await axios
        .delete("/administrativo/anoLectivo/" + this.confirm.item.id)
        .then((response) => {
          this.dialog = false;
          if (response.data.success) {
            this.getAllAnoLectivos();
            this.getAllAnoLectivosActivos();
            this.clear_confirm();
            // Se cambió item.flag_cierre por this.confirm.item, espero esté esté bien
            if (
              this.confirm.item.flag_cierre === 1 &&
              response.data.messageT === "S"
            ) {
              this.logout();
            } else {
              this.getAllAnoLectivos();
              this.getAllAnoLectivosActivos();
            }
          }
          if (response.data.messageT == "W") {
            this.clear_confirm();
          }
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        });
    },

    //---------- [PERIODOS] -----------------------------
    //---------- MODAL AGREGAR/EDITAR PERIODOS-----------
    aggPeriodo() {
      this.bloquearBotonGurdar = false;
      if (this.Periodos.length > 0) {
        let index = this.Periodos.length - 1;
        this.mindatePeriodo = this.Periodos[index].fecha_cierre;
      }
      this.modal_periodo = true;
      this.evento2 = "agregar";
      this.limpiarFormPeriodo();
    },

    //---------- NUEVA CREACIÓN DEL PERIODO ----------------------------------
    async addPeriodos() {
      if (this.$refs.formDatosPeriodo.validate()) {
        this.bloquearBotonGurdar = true;
        let params = this.editedPeriodo;
        this.globalAnoLectivo = this.editedPeriodo.id_ano_lectivo;
        try {
          await axios.post("/administrativo/periodo/", params);
          this.getAllPeriodos();
          this.modal_periodo = false;
          this.limpiarFormPeriodo();

          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Información creada con éxito!",
            tiempo: null,
          });
          this.bloquearBotonGurdar = false;
        } catch (error) {
          this.bloquearBotonGurdar = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    //---------- FUNCIÓN OBTENER PERIODOS --------------
    async getAllPeriodos() {
      let id_ano_lectivo = null;
      if (
        this.datoLogin.id_ano_lectivo == "undefined" ||
        this.datoLogin.id_ano_lectivo == " " ||
        this.datoLogin.id_ano_lectivo === "0" ||
        this.datoLogin.id_ano_lectivo === null
      ) {
        id_ano_lectivo = 0;
      } else {
        id_ano_lectivo = this.datoLogin.id_ano_lectivo;
      }

      let params = {
        id_colegio: this.datoLogin.id_colegio,
        id_anio_lectivo: id_ano_lectivo,
      };
      try {
        let response = await axios.post("administrativo/periodo/list/", params);

        this.Periodos = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });

      }
    },

    //---------- TRAER MIS NIVELES DE ADMINISTRACIÓN -------
    async getAllNivelesAdmin() {



      this.nivelParams = {
        id_ano_lectivo: parseInt(sessionStorage.getItem('id_ano_lectivo')),
        id_colegio_adm_nivel: parseInt(sessionStorage.getItem('id_colegio')),
      }

      try {
        let response = await axios.post(
          "/administrativo/nivel/niveladmin/",
          this.nivelParams
        );
        this.Niveles = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async limpiarFormPeriodo() {
      (this.editedPeriodo = {
        id: 0,
        id_colegio: this.datoLogin.id_colegio,
        nombre_periodo: "",
        fecha_inicio: "",
        fecha_cierre: "",
        id_usuario: this.datoLogin.id,
        id_nivel: [],
        id_ano_lectivo: 0,
      }),
        this.resetValidation();
    },

    //-------- OBTENER ITEM DE EDITAR PERIODO -----
    async editItem2(item) {
      this.mindatePeriodo = await this.dateMinGlobal;
      this.modal_periodo = true;
      this.evento2 = "editar";
      this.limpiarFormPeriodo();

      this.editedPeriodo = Object.assign({}, item);
      //this.Newperiodo = Object.assign({}, item)
    },

    //---------- EDITAR PERIODOS ---------------
    async editPeriodo(id) {
      if (this.$refs.formDatosPeriodo.validate()) {
        this.bloquearBotonGurdar = true;
        let params = this.editedPeriodo;
        params.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
          await axios.put("administrativo/periodo/" + id, params);
          this.getAllPeriodos();

          this.modal_periodo = false;
          this.limpiarFormPeriodo();

          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Información editada con éxito!",
            tiempo: null,
          });
          this.bloquearBotonGurdar = false;
        } catch (error) {
          this.bloquearBotonGurdar = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },



    //---------- METODO QUE PERMITE ELIMINAR UN PERIODO, SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
    async deleteItem2(item) {
      this.confirm.item = item;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.titlewindow = "Eliminar periodo"
      this.confirm.active = true;
      this.confirm.type = 2;
    },

    async deleteItemFeriado(item) {
      this.confirm.item = item;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.titlewindow = "Eliminar feriado"
      this.confirm.active = true;
      this.confirm.type = 2;
    },

    async deleted_periodo() {
      await axios
        .delete("/administrativo/periodo/" + this.confirm.item.id)
        .then((response) => {
          if (response.data.success) {
            this.dialog = false;
            this.clear_confirm();
            this.getAllPeriodos();
          }

          if (response.data.messageT == "W") {
            this.clear_confirm();
          }
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        });
    },

    //---------- [CALENDARIO ACADEMICO] -----------------------------
    async getDiasDeLaSemana() {
      try {
        let response = await axios.get("/mantenimiento/diasSemanas");

        this.diasSemanas = response.data;

      } catch (e) {
        console.log(e);
      }
    },

    verCalendario() {
      this.dialog = true;
    },

    toggleModal() {
    if (this.switch1) {
      this.modalOpen = true; 
      if(!this.dateClean){
        this.dateDisplay = "";
      }
    }
  },

  closeModal() {
    this.modalOpen = false; 
    this.switch1 = false;  
  },

  actualizarDiasFinDeSemana() {
  // Manejar sábado
  const sabado = this.diasSemanas.find(dia => dia.id === 6);
  if (sabado) {
    if (this.sabadoSeleccionado) {
      if (!sabado.selected) {
        sabado.selected = true;
        this.idsSeleccionados.push(sabado.id);
      }
    } else {
      if (sabado.selected) {
        sabado.selected = false;
        this.idsSeleccionados = this.idsSeleccionados.filter(id => id !== sabado.id);
      }
    }
  }

  // Manejar domingo
  const domingo = this.diasSemanas.find(dia => dia.id === 0);
  if (domingo) {
    if (this.domingoSeleccionado) {
      if (!domingo.selected) {
        domingo.selected = true;
        this.idsSeleccionados.push(domingo.id);
      }
    } else {
      if (domingo.selected) {
        domingo.selected = false;
        this.idsSeleccionados = this.idsSeleccionados.filter(id => id !== domingo.id);
      }
    }
  }
  
},
  capturarSeleccion() {
   
    this.diasSeleccionados = this.diasSemanas.filter((dia) => dia.selected);
    this.idsSeleccionados = this.diasSeleccionados.map((dia) => dia.id);
  },

    async enviarSeleccion() {
      this.datos.id_ano_lectivo = parseInt(this.datoLogin.id_ano_lectivo);
      this.datos.id_colegio = parseInt(this.datoLogin.id_colegio);
      this.datos.idsSeleccionados = this.idsSeleccionados;
      this.datos.actv_temporal = this.switch1;
      this.datos.dateDisplay = this.selectedDate;
      const hoy = new Date().toISOString().split('T')[0];
     
       
      if (this.switch1 && this.selectedDate === hoy) {
      
        this.setEnviarMens({
          tipo: "E", 
          mensaje: "Debe seleccionar una fecha cuando la actividad es temporal."
        });
        return; 
      }
      
      try {
        await axios.post(
          "/administrativo/calendarioAcademico",
          this.datos
        ); 
       
        this.diasSelect();
        this.closeModal();
        this.setEnviarMens({
          tipo: "S",
          mensaje: "¡Información actualizada con éxito!",
          tiempo: null,
        });
      } catch (e) {
        console.log(e);
      }
    },

    async diasSelect() {
      let idColegio = parseInt(sessionStorage.getItem("id_colegio"));
      
      try {
        let response = await axios.get(
          `/administrativo/calendarioAcademico/${idColegio}`
        );
      
        this.diasSeleccionados = response.data;
        this.idsSeleccionados = this.diasSeleccionados[0].dias_seleccionados; 
        this.selectedDate = this.diasSeleccionados[0].fecha_desactivar;
        this.dateClean = this.diasSeleccionados[0].actv_temporal;
       
        this.$store.commit("setDiasSeleccionados", this.idsSeleccionados);

     
        this.diasSemanas.forEach((day) => {
          day.selected = this.$store.state.idsDiasSeleccionados.includes(
            day.id
          );
      
        });

        this.idsSeleccionados.forEach((day)=>{
          if (day == 6) {
            this.sabadoSeleccionado = "6";  
          }
          if (day == 0) {
            this.domingoSeleccionado = "0";  
          }
        });      
        
      } catch (e) {
        console.log("error");
      }
    },

    openModalFeriado(item) {
      this.modal_feriado = true;
      this.editedFeriado = Object.assign({}, item);
    },



    async diaFeriado() {
      let fordata = {
        id_ano_lectivo: parseInt(sessionStorage.getItem("id_ano_lectivo"))
      }

      try {

        let response = await axios.post('/administrativo/calendarioFeriado/filter', fordata)
        this.items3 = response.data.map(evento => ({
          name: evento.name,
          start: evento.start,
          end: evento.end,
          color: evento.color,
          details: evento.details,
          id: evento.id
        }));

      } catch (error) {
        console.error('Error al obtener las fechas de feriado:', error);
      }
    },


    async deleteEvent() {
      try {
        await axios.delete("/administrativo/calendarioFeriado/" + this.confirm.item.id)
        this.diaFeriado();
        this.clear_confirm();
      } catch (error) {
        console.log(error);
      }
    },

    async updateEvent(editedFeriado) {
      this.editedFeriado.id_colegio = parseInt(sessionStorage.getItem("id_colegio"));
      this.editedFeriado.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


      try {
        await axios.put(`/administrativo/calendarioFeriado/${editedFeriado.id}/edit`, this.editedFeriado)
        this.diaFeriado();
        this.selectedOpen = false;
        this.currentlyEditing = null;
        this.modal_feriado = false;
        this.setEnviarMens({ tipo: "S", mensaje: "Información Calendario Feriado Actualizada con Éxito.!!", tiempo: null });
      } catch (error) {
        console.log(error);
      }
    },

    async getFeriadosAcademicos() {
      let idColegio = parseInt(sessionStorage.getItem("id_colegio"));
      let response = await axios.get(`/administrativo/calendarioFeriado/${idColegio}`)
      this.editedFeriado = response
    },

    editEvent(id) {
      this.currentlyEditing = id;
    },
  },


};
</script>



<style scoped>
.chip {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 15px;
  color: #ffffff;
}

.custom-card {
  width: 130px;
  height: 120px;
}

.justify {
  flex-grow: 15;
  text-align: center;
}

.modal-content {
  background-color: transparent !important;
}
</style>